import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { News } from "src/app/models/news";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { Events } from "src/app/models/events";
import { NewsService } from "src/app/services/news.service";
import { PARAM_PAGES_PATH } from "../../constants/constants";

import { DynamicFiltersComponent } from "src/app/components/dynamic-filters/dynamic-filters.component";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DrawerModule } from "primeng/drawer";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { NgxPaginationModule } from "ngx-pagination";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { TopNavComponent } from "../../../top-nav/top-nav.component";

@Component({
    selector: "app-manage-events",
    templateUrl: "./manage-events.component.html",
    imports: [DynamicFiltersComponent, ButtonModule, ConfirmDialogModule, DrawerModule, SharedModule, FormsModule, InputTextModule, NgxPaginationModule, Ripple, RouterLink, SelectModule, TableModule, TagModule, ToastModule, TopNavComponent]
})
export class ManageEventsComponent extends AbstractListController<News, any> {
  title = "Pages";
  imageUrl: string;
  pages: Events[];
  pageUrl = PARAM_PAGES_PATH;

  constructor(
    protected newsService: NewsService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(newsService, confirmationService, router, route, PARAM_PAGES_PATH);

    this.cols.set([
      { field: "id", header: "ID", type: "string" },
      { field: "title", header: "Nome", type: "string" },
      { field: "seo_title", header: "Seo Title", type: "string" },
    ])

    this.colsFilter.set([
      { field: "id", header: "Id", type: "string" },
      { field: "title", header: "Nome", type: "string" },
      { field: "seo_title", header: "Seo Title", type: "string" },
    ])


    this.setupDynamicFilters();
  }



}
